var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.$store.state.offline_atlas.fullScreen
        ? "talentMapFullScreen"
        : "",
      attrs: { id: "app" },
      on: { mousedown: _vm.operation, mouseup: _vm.operation },
    },
    [
      [
        _vm.$route.meta["menuType"] === "menu"
          ? _c("router-view")
          : _c("router-view"),
      ],
      _vm.$store.state.audio.audioMsg["isShowAudio"]
        ? _c(
            "div",
            { staticClass: "recorder" },
            [
              _c("my-audio-recorder", {
                ref: "recorder",
                attrs: {
                  playerWidth: _vm.playerWidth,
                  playerHeight: _vm.playerHeight,
                  fileList: _vm.fileList,
                  audioData: _vm.audioData,
                  audioType: _vm.audioType,
                },
                on: { close: _vm.closeAudioConfirm },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.$store.state.audio.truelandUiAudioMsg["isShowAudio"]
        ? _c(
            "div",
            { staticClass: "recorder" },
            [
              _c("AudioRecorder", {
                ref: "oldRecorder",
                attrs: {
                  playerWidth: _vm.playerWidth,
                  playerHeight: _vm.playerHeight,
                  audioData: _vm.oldAudioData,
                  audioType: _vm.audioType,
                  fileList: _vm.oldFileList,
                },
                on: {
                  permissioned: _vm.permissioned,
                  download: _vm.downloadHandler,
                  close: _vm.oldCloseAudioConfirm,
                  pauseHandler: _vm.playAndPauseHandler,
                  playHandler: _vm.playAndPauseHandler,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.$store.state.aiChat.aiChatDrawerVisible
        ? _c("aiChat", {
            attrs: {
              suggestQuestions: _vm.$store.state.aiChat.suggestQuestions,
              interview: _vm.$store.state.aiChat.interview,
              source: _vm.$store.state.aiChat.source,
            },
            on: { close: _vm.handleAiChatClose },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }